import React from 'react'
import iconPlus from 'images/icons/plus.svg'
import placeholder from 'images/placeholders/avatar.png'
import Header from '../../Header'
import Persona from './Persona'
import Loader from '../../Audiences/new/Loader'
import { buttons } from '../../../helpers/const'
import { Provider } from 'react-redux'
import store from '../../store';

class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = { };
  }

  render() {
    let { currentUser, personas, industry, locations, firstSignup } = this.props;
    console.log(currentUser, industry, locations, firstSignup );
    personas = personas.filter(persona => persona.photos.length > 0 );
    return (
      <Provider store={store}>
        <React.Fragment>
          {firstSignup && <Loader defIndustry={industry} defLocations={locations} defCurrentStep={3} />}

          <div className="flex flex-center flex-justify-center mh-100vh" style={{ paddingTop: '80px' }}>
            <Header
              buttonText={buttons.persona.text}
              buttonUrl={buttons.persona.url}
              currentUser={currentUser}
            />

            <div className="col-12 md-px3 mx-auto py-110 sm-py4" style={{ maxWidth: '1010px' }}>
              <h2 className="center title mb-30">Personas</h2>

              <div className="flex flex-justify-center flex-wrap mxn-25">
                {
                  personas && personas.length > 0 && (
                    personas.map(persona => (
                      <Persona key={persona.id} persona={persona} />
                    ))
                  )
                  || (
                    <div>
                      <img alt="" className="block mx-auto" src={placeholder} />

                      <a className="btn btn--primary btn--fs-13 btn--h-32" href={buttons.persona.url}>
                        <img alt="Icon plus" className="mr1" src={iconPlus} />
                        Generate your first persona
                      </a>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </React.Fragment>
      </Provider>
    );
  }
}

export default Index
